
function Cancel() {
    return (
        <h1>Sorry to see you cancelled your Stripe payment!</h1>
    )
}

export default Cancel;